import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const BookmarkIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 14 16" fill="none" {...props}>
    <path
      d="M1.08594 0.917316C1.08594 0.871294 1.12325 0.833984 1.16927 0.833984H12.8359C12.882 0.833984 12.9193 0.871293 12.9193 0.917318V14.2507C12.9193 14.2755 12.9133 14.2877 12.9085 14.2951C12.902 14.305 12.8904 14.3166 12.8732 14.3252C12.856 14.3338 12.8398 14.3362 12.828 14.3353C12.8192 14.3347 12.8058 14.3322 12.7859 14.3173L7.9526 10.6923C7.38964 10.2701 6.61557 10.2701 6.0526 10.6923L1.21927 14.3173C1.19936 14.3322 1.18606 14.3347 1.17725 14.3353C1.16541 14.3362 1.14921 14.3338 1.132 14.3252C1.11479 14.3166 1.10318 14.305 1.09673 14.2951C1.09194 14.2877 1.08594 14.2755 1.08594 14.2507V0.917316Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </IconBase>
);

export default BookmarkIcon;
